import { RootState } from "../../store"
import { Notification } from '../../../types/NotificationSlice';

export const getNotifications = (state: RootState): Notification[] => state.notification.entities.notifications;
